/* eslint-disable react/prop-types */
import React from 'react';
// @ts-ignore - React 18 types issue with react-dom/client
import { createRoot } from 'react-dom/client';
import 'normalize.css';
import './index.css';
import GlobalFonts from './components/abstracts/fonts';
import { configureEnvironment } from './env';
import process from "process";
import { Buffer } from "buffer";
import 'setimmediate'
(window as any).Buffer = Buffer;
(window as any).process = process;

const CommonWrapper: React.FC<React.PropsWithChildren> = (props) => (
  <div>
    <GlobalFonts />
    {props.children}
  </div>
);

const container = document.getElementById('root');
const root = createRoot(container!);

void configureEnvironment()
  .then(async () => {
    const Root = (await import('./Root')).default;
    const { setupDB } = await import('./service/upload/indexedDb');
    setupDB();
    const { setRedirectURL } = await import('./util/urlRedirect');
    const currentURL = window.location.pathname + window.location.search + window.location.hash;
    setRedirectURL(currentURL);
    return <Root />;
  })
  .catch(() => {
    return <div>Application failed to load</div>;
  })
  .then((it) => {
    root.render(<CommonWrapper>{it}</CommonWrapper>);
  });
